import { useAppDispatch } from 'Src/hooks'
import { fileSelectors, fileSlice } from 'Modules'
import { useSelector } from 'react-redux'

const actions = {
	setFileContainersList: fileSlice.actions.setFileContainersList,
}

export const useFileContainers = () => {
	const { setFileContainersList } = useAppDispatch(actions)
	const fileContainersMap = useSelector(fileSelectors.getFileContainersMap)
	return { setFileContainersList, fileContainersMap }
}
